import React from 'react';
import PropTypes from 'prop-types';
import { Table, Button, Input } from 'reactstrap';

export type KeyValueItem = { key: string; value: string };
export type KeyValueGridProperties =
{
    items: KeyValueItem[];
    onChange: (items: KeyValueItem[]) => void;
    addLabel?: string;
    keyPlaceholder?: string;
    valuePlaceholder?: string;
}

function KeyValueGrid
(
    {
        items,
        onChange,
        addLabel = 'Dodaj',
        keyPlaceholder = 'Klucz',
        valuePlaceholder = 'Wartość'
    }
    : KeyValueGridProperties
)
{
    const handleItemChange = (index: number, field: keyof KeyValueItem, value: string) =>
    {
        const next = items.map((item, i) => i === index ? { ...item, [field]: value } : item);
        onChange(next);
    };
    const handleAddRow = () => { onChange([ ...items, { key: '', value: '' } ]); };
    const handleRemoveRow = (index: number) =>
    {
        const next = items.filter((_, i) => i !== index);
        onChange(next);
    };
    const element =
    <div>
        <Table bordered responsive>
            <thead>
                <tr>
                    <th style={{ width: '40%' }}>{keyPlaceholder}</th>
                    <th style={{ width: '50%' }}>{valuePlaceholder}</th>
                    <th style={{ width: '10%' }} />
                </tr>
            </thead>
            <tbody>
                {items.length === 0 && (
                    <tr>
                        <td colSpan={3} className="text-center text-muted">
                            Brak pozycji
                        </td>
                    </tr>
                )}
                {items.map((item, index) => (
                    <tr key={index}>
                        <td>
                            <Input
                                type="text"
                                value={item.key}
                                placeholder={keyPlaceholder}
                                onChange={e => handleItemChange(index, 'key', e.target.value)}
                            />
                        </td>
                        <td>
                            <Input
                                type="text"
                                value={item.value}
                                placeholder={valuePlaceholder}
                                onChange={e => handleItemChange(index, 'value', e.target.value)}
                            />
                        </td>
                        <td className="text-center align-middle">
                            <Button
                                color="link"
                                className="p-0 text-danger"
                                onClick={() => handleRemoveRow(index)}
                                title="Usuń"
                            >
                                <i className="fa fa-trash text-danger" />
                            </Button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </Table>
        <Button color="secondary" onClick={handleAddRow}>
            <i className="fa fa-plus mr-2" />
            {addLabel}
        </Button>
    </div>;
    return element;
}

KeyValueGrid.propTypes =
{
    items: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string,
        value: PropTypes.string
    })).isRequired,
    onChange: PropTypes.func.isRequired,
    addLabel: PropTypes.string,
    keyPlaceholder: PropTypes.string,
    valuePlaceholder: PropTypes.string
};

export default KeyValueGrid;